import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {rulesMap} from 'go/components/rules/rules';
import {evaluateOperator} from 'common/utils';
import {DynamicRadioField as _DynamicRadioField} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicRadioField';

export const DynamicRadioField = (props) => (
  <_DynamicRadioField {...props} {...{rulesMap}} {...{evaluateOperator}} />
);
export default connectWithCore(DynamicRadioField);
